import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { SOURCE_STATUS } from "../../../features/builder.constants";

// Advanced filter of the Rule list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_designer/rule/controller.js, the whitelist get-all filters on.
export const ruleFilterFields = [
  { key: "status", label: "Lifecycle", type: "enum", group: "Details", options: Object.entries(SOURCE_STATUS).map(([value, meta]) => ({ value, label: meta.label })) },
  { key: "trigger_fid", label: "Trigger", type: "select", group: "Details", optionsKey: "triggers", optionLabel: "name", optionValue: "id" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "next_run_at", label: "Next run", type: "datetime", group: "Dates" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
